export default __webpack_public_path__ + "static/media/slide_img.4855aa60.jpg";